
export default function header() {


    const header = document.querySelector('.js-header');

    if ( header ) {
        document.addEventListener('scroll',function(){
            header_scroll();
        });
    }
    
    header_scroll();

    function header_scroll() {
        if( window.pageYOffset > 0 ) {
            header.classList.add("header_scroll");
        } else {
            header.classList.remove("header_scroll");
        }
    }


}